import _toConsumableArray from "/home/travis/build/vslutov/time-tracker/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { type as batchType } from 'redux-batch-middleware';
import { CALL_HISTORY_METHOD } from 'connected-react-router';
export var routerMiddleware = function routerMiddleware(history) {
  return function (store) {
    return function (next) {
      var mayCallHistory = function mayCallHistory(action) {
        if (action.type === CALL_HISTORY_METHOD) {
          var _action$payload = action.payload,
              method = _action$payload.method,
              args = _action$payload.args;
          history[method].apply(history, _toConsumableArray(args));
        }
      };

      return function (action) {
        // location actions may be in batchAction.payload
        if (action.type === batchType) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = action.payload[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var subAction = _step.value;
              mayCallHistory(subAction);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        mayCallHistory(action);
        return next(action);
      };
    };
  };
};